import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
    children: ReactNode;
    componentName: string;
    type: string;
    errorMsg: string;
    replaceDefaultContent: boolean;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            if (this.props.type === "hideError") {
                return <React.Fragment></React.Fragment>;
            }

            return (
                <div className="row">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                    <em className="las la-exclamation-triangle"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Service Temporarily Unavailable</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <p>
                                The {this.props.componentName} service is currently unavailable.There was a problem with this request. We're working on getting it
                                fixed as soon as we can.
                            </p>
                        </div>
                    </div>
                    <div></div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
